import { Form, Formik, FormikProps } from 'formik'
import { FC } from 'react'
import { AlertModal } from './AlertModal'
import { propsInterfaceFormGroupInput } from '../form/FormGroupInput'

const ModalForm: FC<ModalFormProps> = (props) => {
  let _formikProps: any

  const onSubmit = async (value: any) => {
    await new Promise((r) => setTimeout(r, 200))
    if (props.onSubmit !== undefined) props.onSubmit(value, _formikProps)
  }

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={props.initialValues}
        onSubmit={onSubmit}
        validationSchema={props.validationSchema}
      >
        {(formikProps) => (
          <Form autoComplete='off' className='form-input-modal'>
            <AlertModal
              innerHTML={props.innerHTML}
              arrayInput={props.arrayInput}
              title={props.title}
              save={() => {
                return props.save
                  ? props.save(formikProps?.values, formikProps?.setFieldValue, formikProps, props.arrayInput, props )
                  : formikProps.submitForm()

                // if (props.save !== undefined)
                //   return props.save(formikProps?.values, formikProps?.setFieldValue, formikProps)
                // else {
                //   _formikProps = formikProps
                //   return formikProps.submitForm()
                // }
              }}
              setAGGridRef={props.setAGGridRef}
              maxLength={props.maxLength}
              message={props.message}
              hideGrid={props.hideGrid}
              size={props.size}
              onGridReady={props.onGridReady}
              showAddButton={props.showAddButton}
              addButton={props.addButton}
              show={props.show}
              showClose={props.showClose}
              isRefreshGrid={props.isRefreshGrid}
              showSave={props.showSave}
              close={() => {
                return props.close
                  ? props.close(formikProps?.values, formikProps?.setFieldValue)
                  : null
              }}
              formikProps={formikProps}
              showTable={props.showTable}
              tableType={props.tableType}
              columnDefs={props.colum}
              dataRow={props.rows}
              classArrayInput={props.classArrayInput}
              modalFullscreen={props.modalFullscreen}
              tableConditionalRowStyles={props.tableConditionalRowStyles}
              tableSelectableRows={props.tableSelectableRows}
              showHeader={props.showHeader}
              showBody={props.showBody}
              showFooter={props.showFooter}
              saveName={props.saveName}
              closeName={props.closeName}
              showSecondAction={props.showSecondAction}
              secondActionName={props.secondActionName}
              secondAction={props.secondAction}
              showThirdAction={props.showThirdAction}
              thirdActionName={props.thirdActionName}
              thirdAction={props.thirdAction}
              suppressRowClickSelection={props.suppressRowClickSelection}
              rowSelection={props.rowSelection}
              onClick={props.onClick}
              onChange={props.onChange}
              onChangeFile={props.onChangeFile}
              onClearFile={props.onClearFile}
              fileRef={props.fileRef}
              color={props.color}
              onChangeColor={props.onChangeColor}
              onFirstDataRendered={props.onFirstDataRendered}
              
            />
          </Form>
        )}
      </Formik>
    </>
  )
}

ModalForm.defaultProps = {
  onSubmit: undefined,
  showSave: true,
  showAddButton: false,
}
export interface ModalFormProps {
  initialValues?: any
  onSubmit?(value: any, formi: FormikProps<any>): void | undefined
  validationSchema?: any
  arrayInput?: propsInterfaceFormGroupInput[] | []
  classArrayInput?: string
  title?: string
  message?: string
  innerHTML?(): void
  onGridReady?: any
  showAddButton?: boolean
  addButton?(values: any, validateForm: any, touched: any, errors: any, setFieldValue: any): void
  show?: boolean
  maxLength?: string
  showClose?: boolean
  showSave?: boolean
  isRefreshGrid?: boolean
  close?(value?: any, setFieldValue?: any): void
  save?(
    value?: any, 
    setFieldValue?: any, 
    formikProps?: any, 
    params?: any, 
    rowsGridProps?: any): void
  formikProps?: any
  colum?: any
  rows?: any
  showTable?: boolean
  tableType?: 'basic' | 'datatable'
  modalFullscreen?: boolean
  tableConditionalRowStyles?: any
  tableSelectableRows?: any
  size?: 'sm' | 'lg' | 'xl'
  showHeader?: boolean
  showBody?: boolean
  showFooter?: boolean
  saveName?: string
  closeName?: string
  setAGGridRef?: any
  showSecondAction?: boolean
  secondActionName?: string
  secondAction?(value: any, setFieldValue?: any, formikProps?: any): void
  showThirdAction?: boolean
  thirdActionName?: string
  thirdAction?(value: any, setFieldValue?: any, formikProps?: any): void
  hideGrid?: boolean
  suppressRowClickSelection?: boolean
  rowSelection?: string
  onClick?(selectedRows: any, gridRef: any, event: any): void
  onChange?(row: any, dataGrid: any, event: any): void | undefined
  onChangeFile?(
    e: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: any,
    values: any,
    arrayInput: any
  ): any,
  onClearFile?(setFieldValue: any, values: any, arrayInput: any): any,
  fileRef?: any,
  color?: any,
  onChangeColor?(
    color: any,
    e: any,
    setFieldValue: any,
    values: any,
    arrayInput: any
  ): any,
  onFirstDataRendered?(params: any): void | undefined,
  rowsGridProps?:any
}

export { ModalForm }
